var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddressMark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 8.5C15 5.75 12.75 3.5 10 3.5C7.21875 3.5 5 5.75 5 8.5C5 9 5.15625 9.65625 5.5 10.5C5.84375 11.3125 6.3125 12.1875 6.875 13.0625C7.9375 14.7812 9.1875 16.4375 10 17.4375C10.7812 16.4375 12.0312 14.7812 13.125 13.0625C13.6562 12.1875 14.125 11.3125 14.4688 10.5C14.8125 9.65625 15 9 15 8.5ZM16 8.5C16 11.25 12.3438 16.0938 10.7188 18.125C10.3438 18.5938 9.625 18.5938 9.25 18.125C7.65625 16.0938 4 11.25 4 8.5C4 5.1875 6.6875 2.5 10 2.5C13.3125 2.5 16 5.1875 16 8.5ZM8.5 8.5C8.5 9.0625 8.78125 9.53125 9.25 9.8125C9.6875 10.0938 10.2812 10.0938 10.75 9.8125C11.1875 9.53125 11.5 9.0625 11.5 8.5C11.5 7.96875 11.1875 7.5 10.75 7.21875C10.2812 6.9375 9.6875 6.9375 9.25 7.21875C8.78125 7.5 8.5 7.96875 8.5 8.5ZM10 11C9.09375 11 8.28125 10.5312 7.8125 9.75C7.375 9 7.375 8.03125 7.8125 7.25C8.28125 6.5 9.09375 6 10 6C10.875 6 11.6875 6.5 12.1562 7.25C12.5938 8.03125 12.5938 9 12.1562 9.75C11.6875 10.5312 10.875 11 10 11Z",
    fill: "#547eee"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressMark);
export default __webpack_public_path__ + "static/media/address_mark.6dc4b5d56e7a079d0c0c0779d3a4d760.svg";
export { ForwardRef as ReactComponent };